export default Object.freeze({
  RIGHT: 'right',
  LEFT: 'left',
})